module.exports = __webpack_public_path__ + "static/media/CIVI.e3008f80.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/CIVI.png
// module id = 1718
// module chunks = 1